<template>
  <Iframetemple/>
</template>

<script>
import Iframetemple from '../components/LogIn/planPurchase.vue'
export default {
  components: {Iframetemple},

}
</script>

<style>

</style>
